<template>
  <v-menu offset-y left>
    <v-btn
      slot="activator"
      v-if="complete === false && actionItems && actionItems[0]"
      :color="themes.client.light.warningButton"
      round
      small
    >
      <v-icon small left>mdi-account-question</v-icon>
      Incomplete
    </v-btn>
    <v-btn slot="activator" v-else :color="themes.client.light.successButton" round small>
      <v-icon small left>mdi-account-check</v-icon> Complete
    </v-btn>
    <v-card>
      <v-list dense>
        <v-subheader v-if="actionItems && actionItems[0]">
          Candidate Action Required
        </v-subheader>
        <v-subheader v-else> Application Complete </v-subheader>

        <v-list-tile v-for="(action, i) in actionItems" :key="`action-item-${i}`" @click="">
          <v-list-tile-avatar>
            <v-icon
              :color="
                action.critical ? themes.candidate.light.error : themes.candidate.light.warning
              "
            >
              mdi-alert
            </v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <span v-if="action.type.split('::')[1] === 'Assessment'">
              {{
                action.description.includes('APS') ? 'Missing School Subject' : 'Pending Assessment'
              }}
            </span>
            <span v-if="action.type.split('::')[1] === 'Avatar'">
              Missing a Profile Image
            </span>
            <span v-if="action.type.split('::')[1] === 'Biography'">
              Missing a Biography
            </span>
            <span v-if="action.type.split('::')[1] === 'EmailConfirmation'">
              Unconfirmed Email Address
            </span>
            <span v-if="action.type.split('::')[1] === 'Ethnicity'">
              Missing Ethnicity
            </span>
            <span v-if="action.type.split('::')[1] === 'Experience'">
              Missing Work Experience
            </span>
            <span v-if="action.type.split('::')[1] === 'Financial'">
              Missing Financial Needs Assessment
            </span>
            <span v-if="action.type.split('::')[1] === 'Gender'">
              Missing Gender
            </span>
            <span v-if="action.type.split('::')[1] === 'IdentityDocument'">
              Missing a Identity Document
            </span>
            <span v-if="action.type.split('::')[1] === 'Location'">
              Missing Location
            </span>
            <span v-if="action.type.split('::')[1] === 'ProfileQualification'">
              Missing Qualifications
            </span>
            <span v-if="action.type.split('::')[1] === 'Registration'">
              Missing a Proof of Registration
            </span>
            <span v-if="action.type.split('::')[1] === 'Submission'">
              Pending answers to screening questions
            </span>
            <span v-if="action.type.split('::')[1] === 'Transcript'">
              Missing Qualification Transcript
            </span>
            <span v-if="action.type.split('::')[1] === 'SecondaryTranscript'">
              Missing Secondary Transcript
            </span>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: { actionItems: { type: Array, required: true }, complete: Boolean },
}
</script>
